import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringContainsExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";

export class StringContainsExpressionEditor extends ExpressionRuleEditor<StringContainsExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece>contains</ExpressionPiece>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
